module.exports = __webpack_public_path__ + "img/current-expenditure.e673c40d.svg";